var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputText',{attrs:{"identifier":"searchedString","label":_vm.text,"icon":"search"},on:{"onInput":_vm.handleOnInput},model:{value:(_vm.searchedString),callback:function ($$v) {_vm.searchedString=$$v},expression:"searchedString"}})}
var staticRenderFns = []

export { render, staticRenderFns }